import React from "react";
import {List, Avatar, Button, Skeleton, Popover, Input, Col, Row, Select, Modal, Alert, PageHeader} from 'antd';
import moment from "moment";
import Connector from "../../../redux/connector";
import Page from "../../../layout/web/Page";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";

import {AudioOutlined} from '@ant-design/icons';
import {GetUserToken} from "../../../api/token";
import {fetchDataEntity} from "../../../api/entity-data";
import {
    findRecordKey2, findRecordKeyField2,
    findRecordType, GetListField,
    GetRecordDisplayName,
    LoadDataAnyEndpoint,
    SortData,
    SubmitLogInformation,

} from "../../../api/fn";

import {SearchOutlined} from '@ant-design/icons';
import GenericComboBox from "../../../components/General/GenericComboBox";
import {PostToPbx} from "../../../api/http-post";
import ReminderItem from "../../../components/Common/workboard/ReminderItem";

const {TextArea}=Input;

class WorkboardViewReminderPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies: [],
            Projects: [],
            Attributes: [],
            Databases: [],
            Files: [],
            Fields: [],
            selectedCompany: "",
            selectedProject: "",
            initLoading: false,
            loading: false,
            data: [],
            list: [],
            showActions: {},
            searchText: "",
            showNewCase: true,
            newEntry: {},
            Users: [],
            UserVoips: [],
            UserProjects: [],
            Comments: [],

            Reminders:[],

            ActionData: null,
            userComment:"",
            showSubmitComment:false,
            selectedRecord:null,

        };

        this.arrayholder = [];
    }

    componentDidMount = async () => {

        await this.initialReload();
        await this.loadDatabase();
        /*await this.getData((data) => {
            console.log("get data loaded 100% > ", data)
        })*/
    }
    initialReload = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Attributes", "", "", this, undefined, "common/entity/attributes/list");
        await fetchDataEntity("Fields", "", "", this, undefined, "common/entity/Fields/list");
        await fetchDataEntity("Files", "", "", this, undefined, "common/entity/files/list");
        await fetchDataEntity("UserProjects", "", "", this, undefined, "common/entity/AllocationUserProject/list");
        await fetchDataEntity("Databases", "", "", this, undefined, "common/entity/databases/list");
        await fetchDataEntity("Comments", "", "", this, undefined, "common/entity/Comments/list");
        await fetchDataEntity("Reminders", "", "", this, undefined, "common/entity/Reminders/list");
        await this.loadUsers();
        await  this.initializeData();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    findUserName = (username) => {
        for (let i in this.state.Users) {
            let row = this.state.Users[i];
            if (row.Username === username) {
                return row.FullName;
            }
        }
        return username;
    }
    handleChangeCompany = async (val, key) => {
        this.setState({
            [key]: val,
        });

    }
    initializeData = async () => {
        let userInfo = GetUserToken();
        let paramsProject = {};
        let paramsCompany = {};
        if (userInfo.Role !== "super") {
            paramsProject = [
                {key: "Org", val: userInfo.Org, type: "string"},
            ];
            paramsCompany = [
                {key: "CustomerNumber", val: userInfo.Org, type: "string"},
            ];
        }
        await this.fetchData("companies", "Companies", paramsCompany, null);
    }
    fetchData = async (table, stateKey, params, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = params;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })
        await PostToPbx(post, endpoint, async (data) => {
            let res = [];
            if (data !== null) {
                res = data.RESULT;
            }
            await _this.setState({
                [stateKey]: res
            });
            console.log("fetchData response === > ", table, " > ", post, data);
            if (feedback !== null) {
                feedback(res)
            }
        });
    }
    getInfo = () => {
        let userInfo = GetUserToken();
        let extension = "", project = "", name = userInfo.FullName, email = userInfo.Username, phone = userInfo.Phone,
            org = userInfo.Org,role=userInfo.Role;


        for (let i in this.state.UserProjects) {
            let row = this.state.UserProjects[i];
            if (row.user === userInfo.Username) {
                project = row.project;
            }
        }
        for (let i in this.state.UserVoips) {
            let row = this.state.UserVoips[i];
            if (row.user === userInfo.Username) {
                extension = row.extension;
            }
        }

        if(role==="super"){
            org=this.state.selectedCompany;
            project=this.state.selectedProject;
        }

        return {extension, project, name, email, phone, org,role}

    }
    loadDatabase = async () => {

        let _this = this;
        let userInfo = GetUserToken();
        let info = this.getInfo();
        let {project} = info;
        let org = userInfo.Org;

        console.log("> F3 ", org, " > ", info);

        let ls = [];
        let defautlUrl = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        for (let i in this.state.Databases) {
            let row = this.state.Databases[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            let name = GetRecordDisplayName(org, project, row, this.state.Attributes, "displayselection");
            let ref = row.ref;
            //let status=this.findStatus(row),stage=this.findStage(row),priority=this.findPriority(row);
            let {stage, priorityColor, priority, statusColor, status, activity} = this.getLastAction(org, project, ref);
            let description = (<div> Status: <span style={{color: statusColor}}> {status}</span>
                ; Priority: <span style={{color: priorityColor}}>{priority}</span> ; Stage: {stage} ;
                Activity: {activity}</div>);
            ls.push({
                name: name + " (" + ref + ")",
                record: row,
                description: description,
                url: defautlUrl,
                lastUpdate: row.orgdatetime,
                lastStatus: status,
                lastActivity: activity,
                lastPriority: priority,
                lastStage: stage
            })
        }

        _this.arrayholder = ls;
        _this.setState({
            list: ls
        });

        /*await LoadDataNoCondition("databases","list",_this,params,(data)=>{
            data = SortDataDesc("orgdatetime",data);
            _this.arrayholder = data;
            _this.setState({
                list: data
            });
        });*/
    }
    submitCompleteReminder=async (rowIn)=>{


        let _this = this;
        let userInfo = GetUserToken();
        let hub = {};
        hub.Data = rowIn;
        hub.Agent = userInfo.Username;
        hub.Comment = this.state.userComment;
        hub.State = "complete"
        let endpoint = "/desk/action/update-complete";
        await PostToPbx(hub, endpoint, async (data) => {
            await fetchDataEntity("Reminders", "", "", _this, undefined, "common/entity/Reminders/list");
            alert("Thank you , reminder updated!");
            _this.setState({
                userComment:"",
                showSubmitComment:true,
                selectedRecord:rowIn,
            });
        });
    }

    renderProjectSelection = () => {

        let data = [];
        let company = this.state.selectedCompany;
        for (let i in this.state.Projects) {
            let row = this.state.Projects[i];
            console.log("&&&&--isMo> ", company, " > ", row.org)
            if (company === row.org) {
                data.push(row)
            }
        }
        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={data}
                label={"Select Project"}
                name={"selectedProject"}
                message={"Please select your project!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedProject}
                recordOptionKey={"name"}
                recordOptionValue={"name"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderCompaniesSelection = () => {

        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={this.state.Companies}
                label={"Select Company"}
                name={"selectedCompany"}
                message={"Please select your company!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedCompany}
                recordOptionKey={"customernumber"}
                recordOptionValue={"customernumber"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderReminder=()=>{
        let ls=[];
        //ls=this.state.Reminders;
        let {org,project}=this.getInfo();

        if(org===""||project===""){
            return(
                <Alert
                    message="Please select our company and project to view reminder"
                    type="error"
                    style={{margin:20}}
                />
            )
        }

        for(let i in this.state.Reminders){
            let row = this.state.Reminders[i];
            if(row.state==="complete"){continue}
            if(row.org !==org || row.module!==project){
                continue
            }
            ls.push(row);
        }
        console.log("renderReminder > ",this.state.Reminders);
        return ls.map(row=>{
            return <ReminderItem ItemRow={row} _this={this} />
        })
    }



    render() {
        let{role}=this.getInfo()
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>

                    <div style={{minWidth: "100%", padding: 10}}>

                        <div style={styles.radiusMe}>

                            <PageHeader
                                info={this.getInfo()}
                                className="site-page-header"
                                onBack={() => window.history.back()}
                                title={""}
                                subTitle="Helpdesk management system"
                                extra={[
                                    <h3
                                        type="dashed"
                                        icon={<PlusOutlined/>}
                                        style={{
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            margin: 10,
                                        }}
                                        onClick={() => this.openNewCaseDrawer()}
                                    >
                                        Reminder Incident
                                    </h3>,
                                ]}
                            >
                            </PageHeader>
                            {role==="super"?
                            <Row style={{margin:10}}>
                                <Col span={12}>
                                    {this.renderCompaniesSelection()}
                                </Col>
                                <Col span={12}>
                                    {this.renderProjectSelection()}
                                </Col>
                            </Row>:null}

                        </div>

                        {this.renderReminder()}


                    </div>
                </div>
            </Page>

        )
    }

}

export default Connector(WorkboardViewReminderPage);

const styles = {
    radiusMe: {
        border: "1px solid red",
        borderRadius: 5,
    },
    buttonNewCase: {
        minWidth: "18%",
        maxWidth: "18%",
        margin: 10,
    },
    inputSearch: {
        minWidth: "100%",
        maxWidth: "100%",
        margin: 10,
    },
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    },
    makeButtons: {
        /*display:"flex",
        flex:1,
        minWidth:150,
        maxWidth:150,
        justifyContent:"center"*/
    },
    buttonMaker: {
        marginTop: 10,
        minWidth: "50%",
        maxWidth: "50%",

    }
}

